// utils/whatsappHelper/orderLookup/brandNumberPick.ts — Pemilih nomor brand (MURNI, testable).
// Dipakai bila bot tak punya waNumber (mis. bot baru/edited) → tetap ada nomor pengirim
// (insiden 2026-10-16: PUSAT COD waNumber NULL → tombol konfirmasi thanks tanpa nomor).

export interface BrandWaRow {
  phone?: string | null;
  assignedCsAgentId?: string | null;
}

const digits = (v: unknown) => String(v || '').replace(/\D/g, '');

// Pilih: nomor milik CS ybs dulu → kalau tak ada, nomor pertama yang valid (≥10 digit).
export function pickBrandNumber(list: BrandWaRow[] | null | undefined, csId?: string | null): string | null {
  const rows = (Array.isArray(list) ? list : []).filter(r => digits(r?.phone).length >= 10);
  if (!rows.length) return null;
  if (csId) {
    const mine = rows.find(r => r.assignedCsAgentId && String(r.assignedCsAgentId) === String(csId));
    if (mine) return digits(mine.phone);
  }
  return digits(rows[0].phone);
}
